/*
Example state:

export default {
  id: 'user-id',
  name: 'Mert',
  email: 'mert@gladly.com',
};

*/

export default {
  id: null,
  gladlyCustomerId: null,
  name: '',
  email: '',
};
